<div class="modals receipt-of-goods" [class.modals-show]="isModalExpectedReceiptOfGoodsShow"
     [class.modals-hide]="!isModalExpectedReceiptOfGoodsShow">
  <a class="close-modal" (click)="closeModal()"></a>

  <div>
    <input
      [(ngModel)]="filterWaitingGoods"
      (input)="searchWaitingGoods()"
      type="text"
      placeholder="Пошук по: найменуванню, артикул">
    <label class="search-icon"
           *ngIf="filterWaitingGoods === ''">
    </label>
    <label class="cross-clears-search-field"
           *ngIf="filterWaitingGoods !== ''"
           (click)="crossClearsSearchField()">
    </label>
  </div>

  <ul *ngIf="waitingGoods.length > 0">
    <ng-container *ngFor="let group of groupedWaitingGoods">

    <li class="row column" >
      <span class="alert">Очікуємо {{group.date}}<ng-container *ngIf="group.note"> ({{group.note}})</ng-container></span>
    </li>

    <li *ngFor="let goods of group.items" class="row column">
      <p>
        {{ goods.good_name }} ({{ goods.name }})
        <span class="alert">{{ goods.artikul.split('|||')[0] }}</span>
        <span class="quantity"> {{ goods.sum_cnt > 9 ? ">10" : goods.sum_cnt }} шт.</span>
      </p>
    </li>
    </ng-container>
    <ng-container *ngIf="waitingGoodsNoDate?.length">
      <li class="row column">
        <span class="alert">Очікуємо надходження</span>
      </li>

      <li *ngFor="let goods of waitingGoodsNoDate" class="row column">
        <p>
          {{ goods.good_name }} ({{ goods.name }})
          <span class="alert">{{ goods.artikul.split('|||')[0] }}</span>
          <span class="quantity"> {{ goods.sum_cnt > 9 ? ">10" : goods.sum_cnt }} шт.</span>
        </p>
      </li>
    </ng-container>
  </ul>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
